/* @HEADER
 * @version 1.1.722 | 2026-10-23
 * @purpose The app shell, told that a hash overlay is on screen also while the operator's debug window (ZVX-DEV-8099) is: without it the shell's "project of another organisation" placeholder would replace the window exactly when the picture it draws is most needed. Any other hash is passed through untouched and never asks the lock.
 * @sidecar AppShellWithLayoutDebug.tsx.header.md
 * @layer app | @hex adapter | @ctx routing
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-8099

import { useState, type ComponentProps } from 'react'
import { AppShell } from './AppShell'
import { LayoutDebugLockProbe, isLayoutDebugAddress } from '../features/layout-debug/public-api'

type ShellProps = ComponentProps<typeof AppShell>

/**
 * The probe is mounted only on the address, beside the shell (never around it), so moving onto or off the address
 * neither remounts the shell nor makes anybody else's session ask for the lock's entitlement. Off the address the
 * flag is ignored, so a value left over from an earlier visit cannot leak into the next one.
 */
export function AppShellWithLayoutDebug({ hash, hashOverlay = false, ...rest }: ShellProps & { hash: string }) {
  const onAddress = isLayoutDebugAddress(hash)
  const [windowOpen, setWindowOpen] = useState(false)
  return (
    <>
      {onAddress ? <LayoutDebugLockProbe hash={hash} onChange={setWindowOpen} /> : null}
      <AppShell {...rest} hashOverlay={hashOverlay || (onAddress && windowOpen)} />
    </>
  )
}
